import female from '../../Images/female.jpeg';
import male from '../../Images/male.jpeg';

const feeddata=[
    {
        image:female,
        name:'Sumedha',
        city:'Kolkata',
        feed:'I must say I was delighted with the service you provided - it was just what I wanted. This is the second time I have used your services, and both times you provided a faultless experience.'
    },
    {
        image:male,
        name:'Shubham',
        city:'Bihar',
        feed:'Had an awesome time on my trip to Char Dham. The hotels were nice and the itinerary was planned in a practical manner. The team was always available for any kind of help.'
    },
    {
        image:male,
        name:'Ujjwal',
        city:'Jhansi',
        feed:'Your website is a gateway to wanderlust! It is like a treasure trove of experiences waiting to be uncovered. Kudos to your team for crafting such an immersive platform!'
    },
]

export default feeddata;